import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "assets/CloseIcon";
import Backbutton from "assets/backbutton";
import Feedback from "components/common/Feedback";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import { resetAllFilters } from "components/features/AboveProperty/AboveProperty.slice";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import {
  setNavigatedMyList,
  setSelectedList,
  setSelectedListCategory,
  updateRecentlyViewedData
} from "../CorpUser.Slice";
import CorpView from "../CorpView";
import { CreateListDialog } from "./Dialogs/CreateListDialog";
import LeftWrapper from "./LeftWrapper";
import "./MyLists.scss";

const MyLists = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const location = useLocation();
  const navigate = useNavigate();
  const savedFilter = useAppSelector((state) => state.filters.savedFilter);
  const selectedList = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.selectedList);
  const listCategory = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.listCategory);
  const navigatedList = useAppSelector((state: any) => state.CorpDashboard.myListsSelected.navigatedList);
  const savedFiltersAndLists = useAppSelector((state) => state.filters.savedFilter);

  const [open, setOpen] = useState<boolean>();

  useEffect(() => {
    if (selectedList?.id) {
      dispatch(
        updateRecentlyViewedData({
          myList: [
            {
              id: `${selectedList?.id}`,
              myListType: listCategory
            }
          ]
        })
      );
    }
  }, [selectedList]);

  useEffect(() => {
    if (!isEmpty(location.state)) setOpen(location?.state?.toggleOpen);
  }, [location]);

  useEffect(() => {
    dispatch(resetAllFilters());
    if (isEmpty(selectedList)) {
      dispatch(setSelectedList(savedFilter["bookmarked"][0]));
      dispatch(setPageFilter({ pageName: filterPage.listDisplay, defaultFilter: [], modifiedFilter: [] }));
    }
  }, [selectedList]);

  useEffect(() => {
    return () => {
      dispatch(setNavigatedMyList({}));
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(navigatedList)) {
      if (location?.state?.fromDashboard) {
        navigate(location.pathname, { replace: true });
      }
      const selectedMyList = savedFilter[listCategory]?.find(
        (el: any) => el?.id?.toString() === navigatedList?.id?.toString()
      );

      if (selectedMyList) {
        dispatch(setSelectedList(selectedMyList));
        dispatch(
          setPageFilter({
            pageName: filterPage.listDisplay,
            defaultFilter: selectedMyList.filters || []
          })
        );
      }
    }
  }, [navigatedList]);

  useEffect(() => {
    // Parse the URL query parameters
    const searchParams = new URLSearchParams(window.location.search);
    const category = searchParams.get("listCategory");
    const id = searchParams.get("listId");

    // Get the list from saved filters
    const queryParamList = category && savedFiltersAndLists[category];
    // Find the selected list data using the listId from URL
    const selectedData = queryParamList?.find((item: any) => item.id == id);

    // If selected list is different, category is not undefined, and data exists, update the Redux store
    // Prevents re-rendering if query parameter ID doesn't match the selected item's ID.
    if (
      category &&
      selectedList?.id !== selectedData?.id &&
      category in savedFiltersAndLists &&
      !isEmpty(selectedData)
    ) {
      dispatch(setSelectedListCategory(category));
      dispatch(setSelectedList(selectedData));
    }

    // Remove query parameters from the URL after processing
    const baseUrl = window.location.origin + window.location.pathname + `?tab=${searchParams.get("tab")}`;

    // Only modify the URL if query parameters exist
    if (window.location.search.length > 0) {
      window.history.replaceState({}, document.title, baseUrl);
    }
  }, [location, navigate, selectedList]);

  return (
    <>
      <Feedback form="renameDynamicList" />
      <div className="my-list-corp-component">
        {" "}
        <Typography variant={"h3"} showBold className="my-list-corp-heading">
          {translate("common.myListsLabel")}
        </Typography>
        <div className="my-list-corp-desktop"></div>
        <div className="my-list-corp-back-text" onClick={() => setOpen(true)}>
          {" "}
          <Backbutton color={tokens.Text.General.Color}></Backbutton>
          <Typography variant={""} showBold>
            {translate("common.allListsLabel")}
          </Typography>
        </div>
        <div className="my-list-corp-container">
          <div className="my-list-corp-desktop">
            <LeftWrapper open={open} setOpen={setOpen} />
          </div>

          <div className="my-list-corp-right-wrapper">
            {!isEmpty(selectedList) && (
              <CorpView selectedListType={listCategory} selectedList={selectedList} view="myList" />
            )}
          </div>
        </div>
        <div className="my-list-corp-mobile">
          <Drawer
            anchor={"left"}
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
              sx: {
                justifyContent: "space-between",
                width: "100%",
                padding: "16px",
                backgroundColor: "#F6F5F3"
              }
            }}
          >
            <div className="my-list-corp-component">
              <div className="my-list-corp-close-icon">
                <Typography variant={"body2"} className="my-list-corp-heading">
                  {translate("common.myListsLabel")}
                </Typography>
                <IconButton
                  onClick={() => {
                    setOpen(false);
                    navigate("", {
                      state: {
                        toggleOpen: null,
                        backButtonVisible: false
                      }
                    });
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
              {!open && (
                <Typography variant={"h3"} showBold className="my-list-corp-heading">
                  {translate("common.myListsLabel")}
                </Typography>
              )}
              <LeftWrapper open={open} setOpen={setOpen} />
            </div>
          </Drawer>
        </div>
      </div>

      <CreateListDialog />
    </>
  );
};
export default React.memo(MyLists);
